import './App.scss';

import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contactus from './pages/Contact/Contactus';
import FaqSection from './pages/Faqsection';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import CookieEinstellungen from './pages/CookieEinstellungen';
import NotFound from './pages/NotFinde/NotFound';
import ScrollToTop from './ScrollToTop';

import CookieBanner from './components/Cookies/CookieBanner';

function App() {
    return (

            <>
                <ScrollToTop />

                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/singleservice" element={<Services />} />
                    <Route path="/contact" element={<Contactus />} />
                    <Route path="/faq" element={<FaqSection />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                    <Route
                        path="/cookie-einstellungen"
                        element={<CookieEinstellungen />}
                    />
                    <Route path="*" element={<NotFound />} />
                </Routes>

                <CookieBanner />
            </>

    );
}


export default App;